import { getPluralWord } from './getPluralWord';

export const dayPluralForm = (count: number) => {
  return getPluralWord(count, 'ru', {
    one: 'день',
    few: 'дней',
    many: 'дней',
    other: 'дня',
  });
};
